const widgetPin = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8.055 3.038a.294.294 0 0 1 0 .158l-1.53 3.11a.168.168 0 0 1-.085.092L3.689 8.255h-.057a.232.232 0 0 0 0 .417l2.423 1.133-1.68 4.363c-.095.269.431.464.581.222l2.48-3.935 2.44 1.16a.237.237 0 0 0 .24-.017.231.231 0 0 0 .099-.215l-.197-3.091a.541.541 0 0 1 0-.12l1.624-3.278a.485.485 0 0 1 .094-.102l1.042-.64a.24.24 0 0 0 0-.418L8.13 1.506a.256.256 0 0 0-.112 0 .236.236 0 0 0-.184.09.23.23 0 0 0-.042.198z"/></svg>',
};

export { widgetPin as default };
